import { PageTitle } from "@/components/base/PageTitle";
import {
    Button,
    MagicLink,
    PageContainerNewLayout,
    SimpleHeader,
} from "@disasterscience/scaffoldy";
import { isRouteErrorResponse } from "react-router-dom";
import { FriendlyError } from "./FriendlyError";

export const RoutingErrorView = (props: any) => {
    console.error(props);

    return (
        <>
            <PageTitle title="Error" />
            <PageContainerNewLayout>
                {isRouteErrorResponse(props) ? (
                    <FriendlyError errorName={props.statusText} errorStack={props.data} />
                ) : props instanceof Error ? (
                    <FriendlyError errorName={props.message} errorStack={props.stack} />
                ) : (
                    <>
                        <SimpleHeader
                            title={<h4>Not found</h4>}
                            subtitle="The url you requested does not exist."
                        />

                        <MagicLink href="/">
                            <Button>Go Home</Button>
                        </MagicLink>
                    </>
                )}
            </PageContainerNewLayout>
        </>
    );
};
